import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { TranslateService } from "@ngx-translate/core";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { logOutSuccess, resetPassword } from "src/app/store/actions/login/login.actions";
import { AppState, loginStatePasswordReseted } from "src/app/store/reducers";

import { SnackbarService } from "../../services/snackbar/snackbar.service";

import { PasswordResetDTO } from "src/app/models/login/PasswordResetDTO";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { FormUtils } from "../../utils/formUtils";
import { setAuthLanguage } from "../../utils/authenticationUtils";

const NEW_PASSWORD_FORM_PARAMS = {
  password: "password",
  confirmPassword: "confirmPassword",
};

@Component({
  selector: "app-password-recovery",
  templateUrl: "./password-recovery.component.html",
  styleUrls: ["./../login/login.component.scss"],
})
export class PasswordRecoveryComponent implements OnInit, OnDestroy {
  newPasswordForm: FormGroup;

  // Loading Observalbe
  isLoading$: Observable<boolean>;

  // Password Reseted Observable and Subscription
  passwordReseted$: Observable<boolean>;
  passwordResetedSub: Subscription;

  year: number;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private snackbarService: SnackbarService,
    private store: Store<AppState>
  ) {
    this.passwordReseted$ = this.store.pipe(select(loginStatePasswordReseted));
  }

  ngOnInit(): void {
    this.checkRedirect();
    setAuthLanguage(this.translate);
    this.createNewPasswordForm();
    this.setPasswordResetedSubscription();
    this.year = new Date().getFullYear();
  }

  setPasswordResetedSubscription() {
    this.passwordResetedSub = this.passwordReseted$.subscribe((passwordReseted) => {
      if (passwordReseted) {
        this.router.navigate(["login"]);
      }
    });
  }

  checkRedirect() {
    if (
      localStorage.getItem("isAuthenticated") &&
      localStorage.getItem("isAuthenticated") === "true"
    ) {
      this.store.dispatch(logOutSuccess({ isPasswordRecovery: true }));
    }

    const { search } = location;
    if (!search || !search.includes('token')) {
      this.router.navigate(["login"]);
    }
  }

  createNewPasswordForm() {
    this.newPasswordForm = this.fb.group(
      {
        [NEW_PASSWORD_FORM_PARAMS.password]: [
          null,
          [
            Validators.required,
            FormUtils.noWhitespaceValidator,
            Validators.minLength(6),
            Validators.maxLength(55),
          ],
        ],
        [NEW_PASSWORD_FORM_PARAMS.confirmPassword]: [
          null,
          [
            Validators.required,
            FormUtils.noWhitespaceValidator,
            Validators.minLength(6),
            Validators.maxLength(55),
          ],
        ],
      },
      {
        validators: FormUtils.mustMatch(
          NEW_PASSWORD_FORM_PARAMS.password,
          NEW_PASSWORD_FORM_PARAMS.confirmPassword
        ),
      }
    );
  }

  tryResetPassword() {
    this.newPasswordForm.markAllAsTouched();
    if (!this.newPasswordForm.valid) {
      this.snackbarService.show({
        message: this.translate.instant("Auth.PasswordRecoveryFormInvalid"),
        type: SnackbarType.ERROR,
      });
      return;
    }

    const tokenQuery = location.search;
    const passwordReset: PasswordResetDTO = {
      newPassword: this.newPasswordForm.get(NEW_PASSWORD_FORM_PARAMS.password).value
    }

    this.store.dispatch(resetPassword({ passwordReset, tokenQuery }));
  }

  goToLogin() {
    this.router.navigate(["login"]);
  }

  ngOnDestroy() {
    if (this.passwordResetedSub) {
      this.passwordResetedSub.unsubscribe();
    }
  }
}
